// 只转换完整的日期时间值，正文、URL 和普通文本保持原样。
export function normalizeDateTimes(value) {
  if (typeof value === 'string') {
    return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?$/.test(value)
      ? value.replace('T', ' ').slice(0, 19) : value
  }
  if (Array.isArray(value)) return value.map(normalizeDateTimes)
  if (value && Object.getPrototypeOf(value) === Object.prototype) {
    return Object.keys(value).reduce((result, key) => {
      result[key] = normalizeDateTimes(value[key])
      return result
    }, {})
  }
  return value
}
